import faye from 'faye';

export default class Faye {
	constructor(url) {
		this.client = new faye.Client(url);
	}

	publish = (channel, data) => {
		return this.client.publish(channel, data);
	};

	subscribe = (channel, callback) => {
		return this.client.subscribe(channel, callback);
	};

}
